import React from 'react'
import InstructorLogin from '../components/instructor/InstructorLogin';
import InstructorNavbar from '../components/instructor/InstructorNavbar';

const InstructorLoginPage = () => {
    return (

        <>
        <InstructorNavbar/>
        <InstructorLogin/>
        </>
      );
}
 
export default InstructorLoginPage;